import { render, staticRenderFns } from "./DocenteMasivo.vue?vue&type=template&id=38fe6f0c&"
import script from "./DocenteMasivo.vue?vue&type=script&lang=js&"
export * from "./DocenteMasivo.vue?vue&type=script&lang=js&"
import style0 from "./DocenteMasivo.vue?vue&type=style&index=0&id=38fe6f0c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports